import { render, staticRenderFns } from "./addWorkShift.vue?vue&type=template&id=46d2e531&scoped=true&"
import script from "./addWorkShift.vue?vue&type=script&lang=js&"
export * from "./addWorkShift.vue?vue&type=script&lang=js&"
import style0 from "./addWorkShift.vue?vue&type=style&index=0&id=46d2e531&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d2e531",
  null
  
)

export default component.exports